import { RetailerApiClient } from '@/services/RetailerApiClient.js'

export class SubRetailerService {
  static getRetailers(query) {
    return RetailerApiClient.get('subretailers')
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getRetailer(retailerId) {
    return RetailerApiClient.get('subretailers/' + retailerId)
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getStatistics(retailerId, query) {
    return RetailerApiClient.get('subretailers/' + retailerId + '/statistics', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }

  static getOrders(retailerId, query) {
    return RetailerApiClient.get('subretailers/' + retailerId + '/orders', {
      params: query
    })
      .then(response => {
        return response
      })
      .catch(err => {
        throw err
      })
  }
}
